import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useScopedTranslations } from 'pricing-pages-ui-components/i18n/useScopedTranslations';
import { languageToUrl } from 'pricing-pages-ui-components/utils/languageUtils';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useContext, useRef } from 'react';
import { usePublicIntersectionObserver } from '../../hooks/usePublicIntersectionObserver';
import { PublicI18nContext } from '../../context/I18nContext';
import { PublicAeoFeatureList } from './PublicAeoFeatureList';
import { PublicAeoProductInfo } from './PublicAeoProductInfo';
import aeoTranslations from 'i2l?query=sporks!../../../lang/aeo-promo-card/en.lyaml';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getAeoProductUrl() {
  return languageToUrl({
    en: 'https://www.hubspot.com/products/aeo',
    de: 'https://www.hubspot.de/products/aeo',
    es: 'https://www.hubspot.es/products/aeo',
    pt: 'https://br.hubspot.com/products/aeo',
    fr: 'https://www.hubspot.fr/products/aeo',
    ja: 'https://www.hubspot.jp/products/aeo'
  });
}
export const PublicAeoStandalonePromoCard = ({
  monthlyPrice,
  annualPrice,
  currencyCode,
  priceLoading,
  purchaseMotions,
  onSectionViewed,
  onLearnMoreClick
}) => {
  const isMobile = useIsMobile();
  const cardRef = useRef(null);
  const {
    i18nLoader
  } = useContext(PublicI18nContext);
  const T = useScopedTranslations(aeoTranslations, i18nLoader);
  usePublicIntersectionObserver({
    onIntersect: () => onSectionViewed === null || onSectionViewed === void 0 ? void 0 : onSectionViewed(),
    targetRef: onSectionViewed ? cardRef : undefined,
    threshold: 0.9
  });
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsx(T.Skeleton, {
      widths: ['100%'],
      heights: [400],
      children: /*#__PURE__*/_jsx(CardWrapper, {
        ref: cardRef,
        overflow: "hidden",
        flush: true,
        "data-test-id": "public-aeo-standalone-promo-card",
        marginBlockStart: "800",
        marginBlockEnd: "1200",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: isMobile ? 'column' : 'row',
          children: [/*#__PURE__*/_jsx(Flex, {
            flex: isMobile ? undefined : 52,
            flexDirection: "column",
            children: /*#__PURE__*/_jsx(PublicAeoProductInfo, {
              isMobile: isMobile,
              monthlyPrice: monthlyPrice,
              annualPrice: annualPrice,
              currencyCode: currencyCode,
              priceLoading: priceLoading,
              purchaseMotions: purchaseMotions,
              aeoProductUrl: getAeoProductUrl(),
              onLearnMoreClick: onLearnMoreClick
            })
          }), /*#__PURE__*/_jsx(View, {
            backgroundColor: "fill-accent-orange-subtle",
            flexShrink: 0,
            inlineSize: isMobile ? undefined : '18px',
            blockSize: isMobile ? '18px' : undefined
          }), /*#__PURE__*/_jsx(Flex, {
            flex: isMobile ? undefined : 48,
            "data-design": "creative",
            children: /*#__PURE__*/_jsx(PublicAeoFeatureList, {
              isMobile: isMobile
            })
          })]
        })
      })
    })
  });
};